
export const ChANGE_INPUT = 'ChANGE_INPUT';
export const CHANGE_LIST = 'CHANGE_LIST';
export const Del_LIST = 'Del_LIST';
export const SEND_STATE = 'SEND_STATE';
export const ADDRESS_SELECTSUCESS = 'ADDRESS_SELECTSUCESS';
export const ADDRESS_SELECTERROR = 'ADDRESS_SELECTERROR';
export const SUBMIT_ERROR = 'SUBMIT_ERROR';
export const SUBMIT_SUCCESS = 'SUBMIT_SUCCESS';
export const SET_CARNO = 'SET_CARNO';
export const SET_PHONENO = 'SET_PHONENO';
export const SET_AGREE = 'SET_AGREE';
export const SET_REGISTRATION = 'SET_REGISTRATION';
export const SET_DISTRICT = 'SET_DISTRICT';
export const SET_DISNAME = 'SET_DISNAME';
export const SET_SCROLL = 'SET_SCROLL';
export const SET_PATH = 'SET_PATH';
